// Auth Actions
import { LOGIN, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT, CLEAR_AUTH_ERROR, SET_MODULE_GRANTS } from "../types";

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface AccessControl {
  dashboard?: boolean;
  meals?: boolean;
  booking?: boolean;
  settings?: boolean;
  catalogue?: boolean;
  marketing?: boolean;
  create_customer?: boolean;
  create_category?: boolean;
  customer_access?: boolean;
  delivery_access?: boolean;
  team_management?: boolean;
}

export interface AuthUser {
  token: string;
  user_email?: string;
  user_name?: string;
  user_phone_number?: string;
  ip_address?: string;
  access?: AccessControl;
  /**
   * Sidebar ids granted in Settings → Authorization, or null when no per-user
   * grid applies and `access` alone decides. See utils/moduleGrants.
   */
  moduleGrants?: string[] | null;
  device_info?: {
    browser?: string;
    version?: string;
    os?: string;
    platform?: string;
    source?: string;
  };
  [key: string]: any;
}

export interface AuthState {
  isAuthenticated: boolean;
  user: AuthUser | null;
  loading: boolean;
  error: string | null;
}

// Action Creators
export const loginRequest = (credentials: LoginCredentials) => ({
  type: LOGIN,
  payload: credentials,
});

export const loginSuccess = (user: AuthUser) => ({
  type: LOGIN_SUCCESS,
  payload: user,
});

export const loginFailure = (error: string) => ({
  type: LOGIN_FAILURE,
  payload: error,
});

export const logout = () => ({
  type: LOGOUT,
});

export const setModuleGrants = (grants: string[] | null) => ({
  type: SET_MODULE_GRANTS,
  payload: grants,
});

export const clearAuthError = () => ({
  type: CLEAR_AUTH_ERROR,
});

// Legacy action for backward compatibility
export const LoginUserAction = (data: any, onSuccess: (data: any) => void, onError: (error: any) => void) => {
  return {
    type: LOGIN,
    data,
    onSuccess,
    onError,
  };
};